import { z } from 'zod/v4';

const ReportsToSchema = z.object({
	id: z.string(),
	displayName: z.string().nullable().optional(),
	email: z.email().nullable().optional(),
	firstName: z.string().nullable().optional(),
	surname: z.string().nullable().optional(),
});
const WorkSchema = z.object({
	department: z.string().nullable().optional(),
	reportsTo: ReportsToSchema.nullable().optional(),
	manager: z.string().nullable().optional(),
});
const SingleEmployeeSchema = z
	.object({
		id: z.string(),
		displayName: z.string().nullable().optional(),
		email: z.email().nullable().optional(),
		work: WorkSchema.nullable().optional(),
	})
	.transform((employee) => ({
		id: employee.id,
		displayName: employee.displayName,
		email: employee.email,
		department: employee.work?.department || 'N/A',
		managerId:
			employee.work?.manager ||
			(typeof employee.work?.reportsTo === 'string'
				? employee.work.reportsTo
				: undefined),
		managerEmail:
			typeof employee.work?.reportsTo === 'object' &&
			employee.work?.reportsTo?.email
				? employee.work.reportsTo.email
				: undefined,
	}));
const EmployeeCollectionSchema = z.array(SingleEmployeeSchema);
export const EmployeesResponseSchema = z.union([
	z.object({
		error: z.undefined(),
		employees: EmployeeCollectionSchema,
	}),
	z.object({ error: z.string() }),
]);
export type EmployeesResponse = z.infer<typeof EmployeesResponseSchema>;
export type EndpointResponse = {
	error?: string;
	employees?: z.infer<typeof EmployeeCollectionSchema>;
};

export const EndpointResponse = z.custom<EndpointResponse>((value) => {
	return z
		.object({
			error: z.string().nullable().optional(),
			employees: z
				.array(
					z.object({
						id: z.string(),
						displayName: z.string().nullable().optional(),
						email: z.email().nullable().optional(),
						department: z.string().nullable().optional(),
						managerId: z.string().nullable().optional(),
						managerEmail: z.string().nullable().optional(),
					}),
				)
				.nullable()
				.optional(),
		})
		.safeParse(value).success;
});

